import { Injectable } from '@angular/core';
import {
  ApplicationRoutesService,
  RfpApiService,
  RouteEventsStorageService,
  RouterLinks,
} from '@aptitude/shared';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PreRfpNavService {
  private _customCategoryName$ = new ReplaySubject<string>(1);
  customCategoryName$ = this._customCategoryName$.asObservable();
  errorMessage$ = new Subject<string>();
  attachmentUpdateEvent$ = new Subject<string>();
  private _isInvalidCategoryName$ = new ReplaySubject<boolean>(1);
  isInvalidCategoryName$ = this._isInvalidCategoryName$.asObservable();

  constructor(
    private rfpApiService: RfpApiService,
    private routeEventsStorageService: RouteEventsStorageService,
    private applicationRoutes: ApplicationRoutesService,
  ) {}

  setCustomCategoryName(name: string) {
    this._customCategoryName$.next(name);
  }

  setCategoryNameStatus({ isInvalid = false }) {
    this._isInvalidCategoryName$.next(isInvalid);
  }

  updateCustomCategoryName(rfpId: number, customCategoryName: string) {
    return (
      this.rfpApiService
        // Front-end allows empty string but back-end does not. So send value as "Default".
        .renameCategory(rfpId, customCategoryName || 'Default')
        .subscribe({
          complete: () => {
            this.setCustomCategoryName(customCategoryName);
            this.errorMessage$.next('');

            // To update the recently visited links on the home page
            this.routeEventsStorageService.setRecentUrl({
              title: `RFP | ${customCategoryName}`,
              url: this.applicationRoutes.get(RouterLinks.RFP_DETAILS, rfpId),
            });
          },
          error: (errorResponse) =>
            this.errorMessage$.next(errorResponse.error.message),
        })
    );
  }
}
